import { useTranslation } from 'react-i18next'

// Old method to get client name and phone
// kept for backward compatibility with old orders without customerName and customerPhone fields
const parseClient = (client = '') => {
    const m = client.match(/^([^()]*) \((.*)\)$/)
    return m ? { name: m[1], phone: m[2] } : { name: client, phone: client }
}

export const getCustomerName = ({ customerName, customer } = {}) =>
    customerName || parseClient(customer).name || 'N/C'

export const useOrderCustomerName = (order) => getCustomerName(order)

export const useOrderCustomerPhone = (order) => {
    const [t] = useTranslation()

    if (!order) return 'N/C'

    const [phone, code] = (order.customerPhone || '').split(' | ')

    if (!order.customerPhone) return parseClient(order.customer).phone || 'N/C'
    return code ? `${phone}, ${t('order.code')}: ${code}` : phone || 'N/C'
}
